import type { UntypedFormControl } from '@angular/forms';
import type { SitePageEntity } from '@common/types/site-page.type';
import type { MenuItem } from '@web/widgets/menu/type/menu-widget.type';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EButtonLinkType } from '@common/enums';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import {
    BUTTON_LINK_TYPE_PLACEHOLDER,
    LINK_TYPES,
    LINK_TYPE_NAME,
} from '@web/widgets/button/constants/button-widget.const';
import { WebBaseControlSettingsComponent } from '@web/widgets/common/abstract/web-base-control-settings.component';
import { CommonElementsModule } from '@web/widgets/common/common-elements.module';

@Component({
    selector: 'web-menu-settings',
    templateUrl: './menu-settings.component.html',
    styleUrls: ['./menu-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonElementsModule, BsDropdownModule],
})
export class MenuSettingsComponent extends WebBaseControlSettingsComponent<MenuItem> {
    @Input() public pages: SitePageEntity[] = [];

    public readonly EButtonLinkType = EButtonLinkType;
    public readonly LINK_TYPE_NAME = LINK_TYPE_NAME;
    public readonly LINK_TYPES = LINK_TYPES;
    public readonly BUTTON_LINK_TYPE_PLACEHOLDER = BUTTON_LINK_TYPE_PLACEHOLDER;

    protected initForm(): void {
        this.form = this.fb.group({
            name: null,
            linkUrl: null,
            linkType: null,
            isVisible: null,
            isTargetBlank: null,
            pageId: null,
            blockId: null,
            id: null,
            submenuList: null,
        });
    }

    protected setFormData(): void {
        this.form.patchValue(this.item, { emitEvent: false });
    }

    public get name(): UntypedFormControl {
        return this.form.get('name') as UntypedFormControl;
    }

    public setLinkData(linkUrl: string, name: string): void {
        this.linkUrl.setValue(linkUrl, { emitEvent: false });
        this.name.setValue(name);
    }

    public get linkType(): UntypedFormControl {
        return this.form.get('linkType') as UntypedFormControl;
    }

    public get linkUrl(): UntypedFormControl {
        return this.form.get('linkUrl') as UntypedFormControl;
    }

    public get isTargetBlank(): UntypedFormControl {
        return this.form.get('isTargetBlank') as UntypedFormControl;
    }

    public setLinkType(linkType: { name: string; type: EButtonLinkType }): void {
        this.linkType.setValue(linkType.type);
    }

    public setTargetBlank(value: boolean) {
        this.isTargetBlank.setValue(value);
    }
}
